var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 32",
    style: {
      enableBackground: "new 0 0 300 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0.84,1.76 5.4,1.76 9.88,22.72 9.96,22.72 15.5,1.76 18.64,1.76 24.16,22.72 24.23,22.72 28.74,1.76 33.3,1.76  26.17,31.24 22.55,31.24 17.11,9.98 17.03,9.98 11.57,31.24 7.97,31.24  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.99,20.69l-4.13-12.9h-0.08l-4.13,12.89h8.34V20.69z M59.23,24.64H48.4l-2.19,6.59h-4.58L52,1.76h3.62L66,31.24h-4.56 L59.23,24.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.45,14.68h6.56c1.62-0.03,2.84-0.51,3.65-1.46c0.8-0.88,1.2-1.96,1.2-3.24c-0.03-1.54-0.5-2.65-1.43-3.34 c-0.73-0.61-1.79-0.91-3.18-0.91h-6.79L82.45,14.68L82.45,14.68z M78.13,1.76h11.16c2.38,0,4.32,0.65,5.82,1.94 c1.81,1.47,2.75,3.56,2.83,6.29c-0.05,4-1.89,6.72-5.51,8.17l6.61,13.08H93.9l-5.91-12.6h-5.54v12.6h-4.32 C78.13,31.24,78.13,1.76,78.13,1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.98,15.53h6.42c1.61-0.03,2.82-0.54,3.63-1.54c0.77-0.98,1.16-2.06,1.16-3.25c0-0.99-0.16-1.82-0.47-2.5 c-0.33-0.61-0.78-1.09-1.37-1.44c-0.89-0.58-1.92-0.86-3.1-0.83h-6.26L115.98,15.53L115.98,15.53z M111.66,1.76h10.35 c1.12,0,2.21,0.11,3.25,0.32c1.04,0.28,2.1,0.86,3.17,1.74c0.9,0.66,1.63,1.61,2.19,2.83c0.59,1.18,0.88,2.59,0.88,4.2 c0,2.18-0.75,4.17-2.24,5.96c-1.53,1.89-3.76,2.86-6.7,2.91h-6.59v11.51h-4.32L111.66,1.76L111.66,1.76z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.94,10.29 155.05,10.29 155.05,19.15 163.62,19.15 163.62,22.38 155.05,22.38 155.05,31.24 151.94,31.24  151.94,22.38 143.35,22.38 143.35,19.15 151.94,19.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.04,1.76 179.6,1.76 184.08,22.72 184.16,22.72 189.7,1.76 192.84,1.76 198.36,22.72 198.43,22.72 202.94,1.76  207.5,1.76 200.37,31.24 196.75,31.24 191.31,9.98 191.23,9.98 185.77,31.24 182.17,31.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.34,1.76 238.57,1.76 238.57,5.96 224.66,5.96 224.66,14.4 236.54,14.4 236.54,18.36 224.66,18.36  224.66,27.03 238.57,27.03 238.57,31.24 220.34,31.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.64,1.76 269.88,1.76 269.88,5.96 255.96,5.96 255.96,14.68 267.84,14.68 267.84,18.64 255.96,18.64  255.96,31.24 251.64,31.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01,5.72 279.19,5.72 279.19,1.76 299.16,1.76 299.16,5.72 291.33,5.72 291.33,31.24 287.01,31.24  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.198333281febeefd9d501f74faa06907.svg";
export { ForwardRef as ReactComponent };